import { Translations } from "@avinet/adaptive-ui-translate/TranslatorProvider";
import en from "./en";
import no from "./no";

const languages = { en: en as Translations, no: no as Translations };

type LangName = keyof typeof languages;

/**
 * Compare all non-default languages with the default language to ensure the same categories and
 * keys are all present. This assumes the default language contains all used keys.
 */
export default function check() {
  const root = languages.en;

  for (const lang of Object.keys(languages)) {
    const comp = languages[lang as LangName];
    if (comp === root) continue;

    for (const category of Object.keys(root)) {
      if (category === "locale") continue;
      if (!comp.hasOwnProperty(category)) {
        console.error(
          `Missing translation category ${category} in language ${lang}`
        );
        continue;
      }

      const compCat = comp[category];

      for (const key of Object.keys(root[category])) {
        if (!compCat.hasOwnProperty(key))
          console.error(
            `Missing translation ${category}.${key} in language ${lang}`
          );
      }
    }
  }
}
